
import App from "./App.vue";
import router from "./router"
import store from "./store";
import VueCookies from 'vue3-cookies';
import { createApp } from 'vue'
import "./assets/css/owl.carousel.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/style1.css";
import "./assets/css/responsive.css";
import "./assets/fontawesome/css/all.css"
import "./assets/fontawesome/css/bootstrap-icons.css"
import "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import "vue-gtranslate/translator.css";
import "vue-awesome-paginate/dist/style.css";
import VueAwesomePaginate from "vue-awesome-paginate";
import './registerServiceWorker'
import { Dropdown, Offcanvas } from 'bootstrap';
import globalProperties from './globalServices';
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
import { setHeaders } from "@/shared/services/headers";



window.addEventListener('popstate', (event) => {
    if(document.querySelector('.modal.show')) {
        window.location.reload();
    }
});
const getMultiTemplateAuth = async(routeData) => {
    try{
        window.authorization_token = `Bearer ${routeData.query.auth}`;
        store.dispatch('setToken', `Bearer ${routeData.query.auth}`);
        setHeaders();
        let response = await apiCall('get', 'GET_USER_INFO');
        if (response && response.status == 200) {
            if (response?.data?.status == 0 || response?.data?.error || response?.data?.msg) {
                errorToast(response?.data?.error);
            } else {
                setUserDataToStore(response.data);
                store.state.auth.user.token = routeData.query.auth;
            }
        }
        return
    }
    catch(error){
        console.log(error);
        errorToast(error || 'Something went wrong')
    }
};
const setUserDataToStore = async (userData) => {
        let user = {
            notificationSubscribed: null,
            notificationUnsubscribed: null,
            isDemo: userData?.demo || false
        }
        store.dispatch('setUser', {...userData?.user, ...user});
        store.dispatch('setChips', userData?.user?.chips);
        store.dispatch('setEventManage', userData?.event_manage);
};
router.beforeEach(async (to, from, next) => {
    if(document.querySelector('.modal.show')) {
        next(false);
    }
    const dropdownMenu = document.querySelector('.open-menu-btn .dropdown-menu.show');
    if (dropdownMenu) {
        const headAccElement = document.querySelector('.open-menu-btn .dropdown-toggle');
        const headAcc = Dropdown.getInstance(headAccElement);
        if (headAcc) {
            headAcc.hide();
        }
    }
    const offcanvasElement = document.querySelector('.offcanvas.offcanvas-start.show');
    if (offcanvasElement) {
        const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
        if (offcanvasInstance) {
            offcanvasInstance.hide();
            window.store.dispatch('setMenuShow', true)
        }
    }
    const underMaintenance = store.getters.underMaintenance;
    const isMaintenancePage = to.name === 'Maintenance';
    const siteSettings = store.getters.siteSettings;
    const isLoggedIn = store.getters.isAuthenticated;

    if (to.query.auth && !isLoggedIn) {
        await getMultiTemplateAuth(to);
        cookies.set('AUTH_TOKEN', to.query.auth);
        return next({ name: 'Home' });
    }

    if (underMaintenance) {
        if (!isMaintenancePage) {
            next({ name: 'Maintenance' });
        } else {
            next();
        }
    } else {
        if (isMaintenancePage) {
            next({ name: 'Home' });
        } else {
            if(store?.getters.isAuthenticated && !store?.getters?.stateUser?.last_login_at && to.name != 'profile'){
                next({ name: 'profile', params: { type: 'CHANGE_PASSWORD' } });
            }else if (siteSettings && siteSettings.business_type == 1) {
                if (to.path === '/login' || to.path === '/forgot-password' || to.path === '/sign-up') {
                    if (isLoggedIn) {
                        next('/');
                    } else {
                        next();
                    }
                } else {
                        next();
                }
            } else if (siteSettings && siteSettings.business_type == 2) {
                if (to.path === '/login' || to.path === '/forgot-password' || to.path === '/sign-up') {
                    if (isLoggedIn) {
                        next('/');
                    } else {
                        next();
                    }
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    }
});

async function initApp() {
    const app = createApp(App);
    app.use(globalProperties);
    app.use(store);
    app.use(router);
    app.use(VueCookies);
    app.use(VueAwesomePaginate);
    await router.isReady(); 
    app.mount("#app");
};

initApp();